// react
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';
import { APP_DEFAULT_PATH } from 'utils/constants';

// type
import { GuardPropsType } from 'types';

const LoginGuard = ({ children }: GuardPropsType) => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      const page = location?.state?.from ? location.state.from : APP_DEFAULT_PATH;
      navigate(page, {
        state: {
          from: null
        },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location]);

  return children;
};

export default LoginGuard;
